import { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Newspaper } from "lucide-react";

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/news").then((r) => { setItems(r.data.news); setLoading(false); });
  }, []);

  return (
    <PublicLayout>
      <section className="gradient-radial-blue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="section-label">News &amp; Updates</div>
          <h1 className="mt-2 font-display font-bold text-4xl sm:text-5xl text-[#0A192F]">Latest from Way2Efiling</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">Deadline reminders, policy updates, new services and offers.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-slate-500">Loading…</div>
          ) : items.length === 0 ? (
            <div className="text-center py-16">
              <Newspaper className="w-8 h-8 mx-auto text-slate-400" />
              <div className="mt-3 font-medium text-slate-700">No news yet</div>
              <div className="text-sm text-slate-500 mt-1">Check back soon.</div>
            </div>
          ) : (
            <ul className="space-y-4">
              {items.map((n) => (
                <li key={n.id}>
                  <Link
                    to={`/news/${n.slug}`}
                    className="block rounded-xl border border-slate-200 bg-white p-5 hover:shadow-md hover:border-[#1E3A8A]/30 transition-all group"
                    data-testid={`news-item-${n.slug}`}
                  >
                    <div className="text-xs uppercase tracking-widest text-slate-500">
                      {n.published_at ? new Date(n.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : ""}
                    </div>
                    <h2 className="mt-1 font-display font-semibold text-xl text-[#0A192F] group-hover:text-[#1E3A8A]">{n.title}</h2>
                    {n.excerpt && <p className="mt-1.5 text-sm text-slate-600 line-clamp-2">{n.excerpt}</p>}
                    <span className="mt-3 inline-block text-sm text-[#1E3A8A] font-medium">Read article →</span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
